// src/menu-items/Pawn.js
import React, { useEffect, useMemo } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import SellIcon from "@mui/icons-material/Sell";
import OutboxIcon from "@mui/icons-material/Outbox";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import StoreIcon from "@mui/icons-material/Store";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useAuth } from "../hooks/useAuth";
import { hasPermission } from "../utils/permissionUtils";
import { useSelector } from "react-redux";

const PawnRoutes = (overdueData) => {
  const { role } = useAuth();
  console.log("overdueData", overdueData?.overdueData);

  // // ดึงข้อมูลจาก Redux store
  // const overdueData = useSelector((state) => state.overdue.data || []);
  // const overduePawn = useSelector((state) => state.overduePawn.data || []);

  // useEffect(() => {
  //   // ตรวจสอบว่าข้อมูลเป็น undefined หรือ null
  //   if (!overdueData || overdueData.length === 0) {
  //     console.warn("overdueData is undefined or empty");
  //     // เรียกการทำงานอื่นๆ เช่น ดึงข้อมูลใหม่
  //   }

  //   if (!overduePawn || overduePawn.length === 0) {
  //     console.warn("overduePawn is undefined or empty");
  //     // เรียกการทำงานอื่นๆ เช่น ดึงข้อมูลใหม่
  //   }
  // }, [overdueData, overduePawn]);

  const generatePawnRoutes = () => {
    const pawnRoutes = [
      /* Dashboard Menu */ {
        title: "Dashboard",
        items: [
          {
            path: "/pawn/dashboard_pawn",
            name: "Dashboard",
            icon: <DashboardIcon />,
          },
        ],
      },
      /* หมวดหมู่สินค้า โรงรับจำนำ */
      hasPermission(role, ["admin", "AdminA", "AdminM", "owner"]) && {
        title: "สินค้า",
        items: [
          {
            path: "/pawn/all_product_pawn",
            name: "รายการทั้งหมด",
            icon: <Inventory2Icon />,
          },
          {
            path: "/pawn/buy_items_pawn",
            name: "สินค้าที่ซื้อ",
            icon: <RequestPageIcon />,
          },
          {
            path: "/pawn/ready_items_pawn",
            name: "สินค้าพร้อมขาย",
            icon: <ShoppingCartIcon />,
          },
          {
            path: "/pawn/borrow_items_pawn",
            name: "สินค้าถูกยืม/คืน",
            icon: <SwapHorizontalCircleIcon />,
          },
          {
            path: "/pawn/overdue_borrow_items_pawn",
            name: "เกินกำหนดยืม",
            icon: <AccessTimeFilledIcon />,
            status: overdueData?.overdueData,
          },
          {
            path: "/pawn/sold_items_pawn",
            name: "สินค้าขายแล้ว",
            icon: <RemoveShoppingCartIcon />,
          },
          {
            path: "/pawn/overdue_pawn_items_pawn",
            name: "สินค้าหลุดจำนำ",
            icon: <HourglassBottomIcon />,
          },
        ],
      },
      /* หมวดหมู่รายการ โรงรับจำนำ */
      hasPermission(role, ["admin", "AdminA", "AdminM", "owner"]) && {
        title: "รายการ",
        items: [
          {
            path: "/pawn/sell_on_consignmen_pawn",
            name: "รายการขายฝาก",
            icon: <SellIcon />,
            status: overdueData?.overduePawn,
          },
          {
            path: "/pawn/redemption_items_pawn",
            name: "รายการไถ่ถอน",
            icon: <OutboxIcon />,
          },
          {
            path: "/pawn/setting_price_pawn",
            name: "ตั้งค่าราคาขาย",
            icon: <PaidIcon />,
          },
          {
            path: "/pawn/list_by_customer_pawn",
            name: "รายการแยกตามชื่อลูกค้า",
            icon: <ContactPageIcon />,
          },
          { path: "/pawn/bin_pawn", name: "ถังขยะ", icon: <DeleteIcon /> },
          {
            path: "/pawn/customer_list_pawn",
            name: "รายชื่อลูกค้า",
            icon: <PeopleAltIcon />,
          },
        ],
      },
      /* หมวดหมู่รายงาน โรงรับจำนำ */
      hasPermission(role, ["admin", "AdminA", "AdminM", "owner"]) && {
        title: "รายงาน",
        items: [
          {
            path: "/pawn/inventory_pawn",
            name: "ทรัพย์คงคลัง",
            icon: <StoreIcon />,
          },
          {
            path: "/pawn/income_expenses_pawn",
            name: "รายรับ-รายจ่าย",
            icon: <PriceChangeIcon />,
          },
          {
            path: "/pawn/interest_pawn",
            name: "ดอกเบี้ย",
            icon: <TrendingUpIcon />,
          },
        ],
      },
      /* หมวดหมู่นำเข้าข้อมูลย้อนหลัง โรงรับจำนำ */
      // hasPermission(role, ["admin", "AdminA", "AdminM", ]) && {
      //   title: "นำเข้าข้อมูลย้อนหลัง",
      //   items: [
      //     {
      //       path: "/pawn/import_data_pawn",
      //       name: "รายการนำเข้า",
      //       icon: <SummarizeIcon />,
      //     },
      //     {
      //       path: "/pawn/import_information_pawn",
      //       name: "นำเข้าข้อมูลขายฝาก",
      //       icon: <SellIcon />,
      //     },
      //     {
      //       path: "/pawn/import_information_buy_pawn",
      //       name: "นำเข้าข้อมูลซื้อ",
      //       icon: <RequestPageIcon />,
      //     },
      //   ],
      // },
    ].filter(Boolean);

    return pawnRoutes;
  };

  return generatePawnRoutes(); // Call the function to get the routes
};

export default PawnRoutes;
